import { WebApiService } from '../../../../plugins/webApiService'
import { Events } from '../../../../plugins/events'
import { SendRequestModel } from '../../../../plugins/models/SendRequestModel'
import AddScenarioRequest from '../../../../projects/autotest/i-service/scenario-manager/models/request/AddScenarioRequest';
import EditScenarioRequest from '../../../../projects/autotest/i-service/scenario-manager/models/request/EditScenarioRequest';
import RemoveScenarioRequest from '../../../../projects/autotest/i-service/scenario-manager/models/request/RemoveScenarioRequest';
import GetScenarioRequest from '../../../../projects/autotest/i-service/scenario-manager/models/request/GetScenarioRequest';
import SearchScenarioRequest from '../../../../projects/autotest/i-service/scenario-manager/models/request/SearchScenarioRequest';
import AddScenarioFolderRequest from '../../../../projects/autotest/i-service/scenario-manager/models/request/AddScenarioFolderRequest';
import EditScenarioFolderRequest from '../../../../projects/autotest/i-service/scenario-manager/models/request/EditScenarioFolderRequest';
import RemoveScenarioFolderRequest from '../../../../projects/autotest/i-service/scenario-manager/models/request/RemoveScenarioFolderRequest';
import GetScenarioFolderRequest from '../../../../projects/autotest/i-service/scenario-manager/models/request/GetScenarioFolderRequest';
import SearchScenarioFolderRequest from '../../../../projects/autotest/i-service/scenario-manager/models/request/SearchScenarioFolderRequest';
import WsResponseModelT from '../../../../schema-builder-server/models/WsResponseModelT';
import ScenarioInfo from '../../../../projects/autotest/i-service/scenario-manager/models/ScenarioInfo';
import ScenarioInfoCollectionResponse from '../../../../projects/autotest/i-service/scenario-manager/models/response/ScenarioInfoCollectionResponse';
import ScenarioFolderInfo from '../../../../projects/autotest/i-service/scenario-manager/models/ScenarioFolderInfo';
import ScenarioFolderInfoCollectionResponse from '../../../../projects/autotest/i-service/scenario-manager/models/response/ScenarioFolderInfoCollectionResponse';

export default class ScenarioMangerService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	AddScenarioEvent = new Events<WsResponseModelT<Boolean>>();
	EditScenarioEvent = new Events<WsResponseModelT<Boolean>>();
	RemoveScenarioEvent = new Events<WsResponseModelT<Boolean>>();
	GetScenarioEvent = new Events<WsResponseModelT<ScenarioInfo>>();
	GetListScenariosEvent = new Events<WsResponseModelT<ScenarioInfoCollectionResponse>>();
	AddScenarioFolderEvent = new Events<WsResponseModelT<Boolean>>();
	EditScenarioFolderEvent = new Events<WsResponseModelT<Boolean>>();
	RemoveScenarioFolderEvent = new Events<WsResponseModelT<Boolean>>();
	GetScenarioFolderEvent = new Events<WsResponseModelT<ScenarioFolderInfo>>();
	GetListScenarioFoldersEvent = new Events<WsResponseModelT<ScenarioFolderInfoCollectionResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ScenarioMangerService', 'AddScenario', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.AddScenarioEvent.trigger(res);
		});
		webApiService.on('ScenarioMangerService', 'EditScenario', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditScenarioEvent.trigger(res);
		});
		webApiService.on('ScenarioMangerService', 'RemoveScenario', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveScenarioEvent.trigger(res);
		});
		webApiService.on('ScenarioMangerService', 'GetScenario', 'Main', (res: WsResponseModelT<ScenarioInfo>) => {
			self.GetScenarioEvent.trigger(res);
		});
		webApiService.on('ScenarioMangerService', 'GetListScenarios', 'Main', (res: WsResponseModelT<ScenarioInfoCollectionResponse>) => {
			self.GetListScenariosEvent.trigger(res);
		});
		webApiService.on('ScenarioMangerService', 'AddScenarioFolder', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.AddScenarioFolderEvent.trigger(res);
		});
		webApiService.on('ScenarioMangerService', 'EditScenarioFolder', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditScenarioFolderEvent.trigger(res);
		});
		webApiService.on('ScenarioMangerService', 'RemoveScenarioFolder', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveScenarioFolderEvent.trigger(res);
		});
		webApiService.on('ScenarioMangerService', 'GetScenarioFolder', 'Main', (res: WsResponseModelT<ScenarioFolderInfo>) => {
			self.GetScenarioFolderEvent.trigger(res);
		});
		webApiService.on('ScenarioMangerService', 'GetListScenarioFolders', 'Main', (res: WsResponseModelT<ScenarioFolderInfoCollectionResponse>) => {
			self.GetListScenarioFoldersEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	async AddScenario(request: AddScenarioRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ScenarioMangerService',
			Method: 'AddScenario',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async EditScenario(request: EditScenarioRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ScenarioMangerService',
			Method: 'EditScenario',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async RemoveScenario(request: RemoveScenarioRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ScenarioMangerService',
			Method: 'RemoveScenario',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async GetScenario(request: GetScenarioRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ScenarioMangerService',
			Method: 'GetScenario',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async GetListScenarios(request: SearchScenarioRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ScenarioMangerService',
			Method: 'GetListScenarios',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async AddScenarioFolder(request: AddScenarioFolderRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ScenarioMangerService',
			Method: 'AddScenarioFolder',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async EditScenarioFolder(request: EditScenarioFolderRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ScenarioMangerService',
			Method: 'EditScenarioFolder',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async RemoveScenarioFolder(request: RemoveScenarioFolderRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ScenarioMangerService',
			Method: 'RemoveScenarioFolder',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async GetScenarioFolder(request: GetScenarioFolderRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ScenarioMangerService',
			Method: 'GetScenarioFolder',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async GetListScenarioFolders(request: SearchScenarioFolderRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ScenarioMangerService',
			Method: 'GetListScenarioFolders',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	async addScenarioAsync(request: AddScenarioRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ScenarioMangerService',
				Method: 'AddScenario',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async editScenarioAsync(request: EditScenarioRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ScenarioMangerService',
				Method: 'EditScenario',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async removeScenarioAsync(request: RemoveScenarioRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ScenarioMangerService',
				Method: 'RemoveScenario',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async getScenarioAsync(request: GetScenarioRequest): Promise<ScenarioInfo> {
		return new Promise<ScenarioInfo>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ScenarioMangerService',
				Method: 'GetScenario',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ScenarioInfo>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ScenarioInfo)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async getListScenariosAsync(request: SearchScenarioRequest): Promise<ScenarioInfoCollectionResponse> {
		return new Promise<ScenarioInfoCollectionResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ScenarioMangerService',
				Method: 'GetListScenarios',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ScenarioInfoCollectionResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ScenarioInfoCollectionResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async addScenarioFolderAsync(request: AddScenarioFolderRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ScenarioMangerService',
				Method: 'AddScenarioFolder',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async editScenarioFolderAsync(request: EditScenarioFolderRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ScenarioMangerService',
				Method: 'EditScenarioFolder',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async removeScenarioFolderAsync(request: RemoveScenarioFolderRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ScenarioMangerService',
				Method: 'RemoveScenarioFolder',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async getScenarioFolderAsync(request: GetScenarioFolderRequest): Promise<ScenarioFolderInfo> {
		return new Promise<ScenarioFolderInfo>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ScenarioMangerService',
				Method: 'GetScenarioFolder',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ScenarioFolderInfo>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ScenarioFolderInfo)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async getListScenarioFoldersAsync(request: SearchScenarioFolderRequest): Promise<ScenarioFolderInfoCollectionResponse> {
		return new Promise<ScenarioFolderInfoCollectionResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ScenarioMangerService',
				Method: 'GetListScenarioFolders',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ScenarioFolderInfoCollectionResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ScenarioFolderInfoCollectionResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}